export default __webpack_public_path__ + "static/media/GilroyBold.a64a9abe.otf";